import AccountForm from "./account-form";

export default AccountForm;